import {
  AoaSheet,
  AxisMapped,
  FieldType,
  ReportSheet, YAxisID,
} from "interfaces/report";
import * as _ from "lodash";
import { Bar, Line } from "react-chartjs-2";
import numeral from "numeral";

interface Props {
  sheet: ReportSheet<AxisMapped>;
}

export const StackedBarLineChart = ({ sheet }: Props) => {
  sheet.yAxis = sheet.yAxis.filter((item) => !item.hide && item.active);

  const mergedYValue = _.chain(sheet.yAxis)
    .map("value")
    .uniq()
    .join(" | ")
    .value();

  const data = {
    labels: sheet.xAxis.map((item) => item.value),
    datasets: sheet.yAxis
      .filter((item) => !item.hide && item.active)
      .map((item) => {
        const color = item.color;
        const data = sheet.data
          .find((items) => items[0] === item.value)
          ?.slice(1) as AoaSheet;

        return {
          data: data,
          borderColor: color,
          label: item.value,
          backgroundColor: color + "80",
          stack: "combined",
          ...(item.fieldType === FieldType.BAR ? { type: "bar" } : {}),
        } as any;
      }),
  };

  return (
    <Line
      options={{
        scales: {
          y: {
            ticks: {
              // Include a dollar sign in the ticks
              callback: function(value, index, ticks) {
                const unit = sheet.yAxis.find((axis) => axis.yAxisID === YAxisID.Y)?.unit;
                if (unit === '%') {
                  return numeral(value).format('0%');
                } else {
                  return numeral(value).format(`${unit}0.0a`);
                }
              }
            },
            title: {
              display: true,
              text: mergedYValue,
            },
          },
        },
        responsive: true,
        plugins: {
          datalabels: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label(tooltipItem) {
                const value = tooltipItem.parsed.y;
                const unit = sheet.yAxis.find((axis) => axis.yAxisID === YAxisID.Y)?.unit;

                let formatted = '';
                if (unit === '%') {
                  formatted = numeral(value).format('0.0%');
                } else if (unit === '$') {
                  formatted = numeral(value).format('$0,0.00');
                } else {
                  formatted = value.toLocaleString("en-AU", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                  });
                }

                return `${tooltipItem.dataset.label}: ${formatted}`;
              },
            },
          },
          legend: {
            display: false,
          },
        },
      }}
      data={data}
    />
  );
};
